module.exports = require('./Switch');


//////////////////
// WEBPACK FOOTER
// /Users/ddcat/project/ant-design-pro-site/ant-design-pro-site/scaffold/node_modules/_rc-switch@1.6.0@rc-switch/es/index.js
// module id = 357
// module chunks = 0